/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { loginApi } from "api/services/authentication";
import { useEffect, useLayoutEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
// import { resetFunctionwithlogin } from "../../../components/ResetFunction";
import { Button } from "components/Button";
import { useAuth } from "context/userContext";
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

const Login = () => {
  const details = localStorage.getItem("loginDetails");

  const loginData = JSON.parse(details);

  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false)
  const {token, login} = useAuth();


  // const onSubmit = (data) => {
  //   const currentUser = loginData?.find((item) => item?.email === data?.email);
  //   if (!currentUser) {
  //     setEmailError(true); // Email is not registered
  //     navigate("/");
  //   } else if (currentUser.password === data?.password) {
  //     setEmailError(false); // Email is registered, and password is correct
  //     const Value = {
  //       email: data?.email,
  //       password: data?.password,
  //     };
  //     dispatch(login(Value));
  //     localStorage.setItem("credencial", JSON.stringify(Value));
  //     navigate("/admin-dashboard");
  //     resetFunctionwithlogin();
  //   } else {
  //     setEmailError(true); // Email is registered, but the password is incorrect
  //     navigate("/");
  //   }
  // };

  function refreshPage() {
    window.location.reload(false);
  }

  // useEffect(()=>{
  //   if(token){
  //     navigate("/employee-dashboard");
  //   }
  // },[token])
  const onSubmit = (data) => {
    console.log(data, "DDDDD")
    setLoading(true)

    loginApi(data).then(response=>{
      console.log(response.data, "DAAAA")
      login(response.data)
      // console.log(token, "token")
      setLoading(false)



    }).catch(err=>{
      console.log(err.response?.data?.detail)
      setLoading(false)
      setError("root", {
        type: "400",
        message:  err.response?.data?.detail
      })
      // setError("root", err.response?.data?.detail)

    })

  };

  useEffect(() => {
    // Prevent body scrolling
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  const [eye, seteye] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div style={{ 
      height: "100vh",
      maxHeight: "100vh",
      overflow: "auto",
      background: isMobile ? "#ffffff" : "#f9fafb",
      display: "flex",
      alignItems: isMobile ? "flex-start" : "center",
      justifyContent: "center",
      padding: isMobile ? "0" : "20px",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: "100%"
    }}>

      <div className="container" style={{ 
        position: "relative", 
        zIndex: 1, 
        width: "100%", 
        maxWidth: "100%",
        height: "100%",
        display: "flex",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "center",
        overflow: isMobile ? "auto" : "hidden",
        padding: isMobile ? "0" : "20px"
      }}>
        <div className="row justify-content-center w-100" style={{ margin: 0, height: isMobile ? "auto" : "100%", display: "flex", alignItems: isMobile ? "flex-start" : "center" }}>
          <div className={isMobile ? "col-12" : "col-12 col-sm-10 col-md-8 col-lg-5"} style={{ 
            display: "flex",
            flexDirection: "column",
            justifyContent: isMobile ? "flex-start" : "center",
            maxHeight: isMobile ? "none" : "100%",
            overflow: isMobile ? "visible" : "hidden",
            padding: isMobile ? "40px 24px" : "0",
            minHeight: isMobile ? "100vh" : "auto"
          }}>
            {/* Logo - Centered */}
            <div className="text-center" style={{ 
              marginBottom: isMobile ? "48px" : "32px",
              flexShrink: 0,
              marginTop: isMobile ? "0" : "0"
            }}>
              <Link to="/employee-dashboard" style={{ display: "inline-block" }}>
                <img 
                  src={"https://storage.mealtrackr.io/internal/Nandos-Logo.png"} 
                  alt="Nando's ESS" 
                  style={{
                    maxWidth: isMobile ? "140px" : "180px",
                    height: "auto",
                    filter: isMobile ? "none" : "drop-shadow(0 4px 12px rgba(0,0,0,0.15))"
                  }}
                />
              </Link>
            </div>

            {/* Desktop Form - No Card */}
            {!isMobile && (
              <form onSubmit={handleSubmit(onSubmit)} style={{ 
                width: "100%",
                maxWidth: "400px",
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
                flexShrink: 0
              }}>
                {errors?.root?.message && (
                  <div style={{
                    padding: "12px 16px",
                    background: "#fee2e2",
                    border: "1px solid #fecaca",
                    borderRadius: "8px",
                    marginBottom: "16px"
                  }}>
                    <span style={{ color: "#dc2626", fontSize: "13px", fontWeight: "500" }}>
                      {errors?.root?.message}
                    </span>
                  </div>
                )}

                {/* Header */}
                <div className="text-center" style={{ 
                  marginBottom: "24px",
                  flexShrink: 0
                }}>
                  <h3 style={{ 
                    fontSize: "24px", 
                    fontWeight: "700", 
                    color: "#1f2937",
                    marginBottom: "4px"
                  }}>
                    Welcome Back
                  </h3>
                  <p style={{ 
                    fontSize: "13px", 
                    color: "#6b7280",
                    margin: 0
                  }}>
                    Sign in to access your dashboard
                  </p>
                </div>

                {/* Email Field */}
                <div style={{ marginBottom: "20px", flexShrink: 0 }}>
                  <label style={{ 
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "8px"
                  }}>
                    Email Address
                  </label>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <div style={{ position: "relative" }}>
                        <div style={{
                          position: "absolute",
                          left: "16px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#9ca3af",
                          fontSize: "16px",
                          zIndex: 1
                        }}>
                          <i className="las la-envelope"></i>
                        </div>
                        <input
                          className={`form-control ${errors?.email ? "error-input" : ""}`}
                          type="email"
                          onChange={field.onChange}
                          value={field.value || ""}
                          autoComplete="username"
                          placeholder="Enter your email"
                          style={{
                            paddingLeft: "44px",
                            paddingRight: "16px",
                            height: "48px",
                            borderRadius: "10px",
                            border: errors?.email ? "1px solid #dc2626" : "1px solid #e5e7eb",
                            fontSize: "14px",
                            transition: "all 0.2s",
                            background: "#f9fafb",
                            width: "100%",
                            color: "#000000"
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#D3001A";
                            e.target.style.background = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = errors?.email ? "#dc2626" : "#e5e7eb";
                            e.target.style.background = "#f9fafb";
                          }}
                        />
                      </div>
                    )}
                  />
                  {errors.email?.message && (
                    <span style={{ 
                      color: "#dc2626", 
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      {errors.email?.message}
                    </span>
                  )}
                </div>

                {/* Password Field */}
                <div style={{ marginBottom: "20px", flexShrink: 0 }}>
                  <div style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    marginBottom: "8px"
                  }}>
                    <label style={{ 
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#374151"
                    }}>
                      Password
                    </label>
                    <Link 
                      to="/forgot-password"
                      style={{ 
                        fontSize: "13px",
                        color: "#D3001A",
                        textDecoration: "none",
                        fontWeight: "500",
                        whiteSpace: "nowrap"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                        e.currentTarget.style.color = "#b91c1c";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                        e.currentTarget.style.color = "#D3001A";
                      }}
                    >
                      Forgot password?
                    </Link>
                  </div>
                  <div style={{ position: "relative" }}>
                    <div style={{
                      position: "absolute",
                      left: "16px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#9ca3af",
                      fontSize: "16px",
                      zIndex: 1
                    }}>
                      <i className="las la-lock"></i>
                    </div>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <input
                          className={`form-control ${errors?.password ? "error-input" : ""}`}
                          type={eye ? "password" : "text"}
                          value={field.value || ""}
                          onChange={field.onChange}
                          autoComplete="current-password"
                          placeholder="Enter your password"
                          style={{
                            paddingLeft: "44px",
                            paddingRight: "44px",
                            height: "48px",
                            borderRadius: "10px",
                            border: errors?.password ? "1px solid #dc2626" : "1px solid #e5e7eb",
                            fontSize: "14px",
                            transition: "all 0.2s",
                            background: "#f9fafb",
                            width: "100%",
                            color: "#000000"
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#D3001A";
                            e.target.style.background = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = errors?.password ? "#dc2626" : "#e5e7eb";
                            e.target.style.background = "#f9fafb";
                          }}
                        />
                      )}
                    />
                    <span
                      onClick={onEyeClick}
                      style={{
                        position: "absolute",
                        right: "16px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#D3001A",
                        cursor: "pointer",
                        fontSize: "18px",
                        transition: "color 0.2s",
                        padding: "4px",
                        zIndex: 2
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = "#b91c1c"}
                      onMouseLeave={(e) => e.currentTarget.style.color = "#D3001A"}
                      className={`fa-solid ${eye ? "fa-eye-slash" : "fa-eye"}`}
                    />
                  </div>
                  {errors.password?.message && (
                    <span style={{ 
                      color: "#dc2626", 
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      {errors.password?.message}
                    </span>
                  )}
                </div>

                {/* Submit Button */}
                <div style={{ marginTop: "32px" }}>
                  <Button 
                    loading={loading} 
                    disabled={loading} 
                    label={loading ? "Signing in..." : "Sign in"} 
                    type="submit" 
                    className="btn btn-primary w-100"
                    style={{
                      height: "48px",
                      borderRadius: "10px",
                      fontSize: "16px",
                      fontWeight: "600",
                      background: loading ? "#9ca3af" : "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      border: "none",
                      boxShadow: loading ? "none" : "0 4px 12px rgba(211, 0, 26, 0.3)",
                      transition: "all 0.3s",
                      width: "100%",
                      color: "#ffffff"
                    }}
                  />
                </div>
              </form>
            )}

            {/* Mobile Header - Clean, no icon */}
            {isMobile && (
              <div style={{ 
                marginBottom: "32px",
                flexShrink: 0
              }}>
                <h1 style={{ 
                  fontSize: "28px", 
                  fontWeight: "400", 
                  color: "#000000",
                  marginBottom: "8px",
                  lineHeight: "1.2"
                }}>
                  Sign in
                </h1>
              </div>
            )}

            {/* Mobile Form */}
            {isMobile && (
              <form onSubmit={handleSubmit(onSubmit)} style={{ 
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
                overflow: "hidden",
                width: "100%"
              }}>
                {errors?.root?.message && (
                  <div style={{
                    padding: "12px 16px",
                    background: "#fee2e2",
                    border: "1px solid #fecaca",
                    borderRadius: "8px",
                    marginBottom: "12px"
                  }}>
                    <span style={{ color: "#dc2626", fontSize: "12px", fontWeight: "500" }}>
                      {errors?.root?.message}
                    </span>
                  </div>
                )}

                {/* Email Field */}
                <div style={{ marginBottom: "24px", flexShrink: 0 }}>
                  <Controller
                    name="email"
                    control={control}
                    render={({ field }) => (
                      <div style={{ position: "relative" }}>
                        <input
                          className={`form-control ${errors?.email ? "error-input" : ""}`}
                          type="email"
                          onChange={field.onChange}
                          value={field.value || ""}
                          autoComplete="username"
                          placeholder="Email"
                          style={{
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            height: "52px",
                            borderRadius: "4px",
                            border: errors?.email ? "1px solid #dc2626" : "1px solid #000000",
                            fontSize: "16px",
                            transition: "all 0.2s",
                            background: "#ffffff",
                            width: "100%",
                            color: "#000000"
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#D3001A";
                            e.target.style.background = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = errors?.email ? "#dc2626" : "#000000";
                            e.target.style.background = "#ffffff";
                          }}
                        />
                      </div>
                    )}
                  />
                  {errors.email?.message && (
                    <span style={{ 
                      color: "#dc2626", 
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      {errors.email?.message}
                    </span>
                  )}
                </div>

                {/* Password Field */}
                <div style={{ marginBottom: "24px", flexShrink: 0 }}>
                  <div style={{ position: "relative" }}>
                    <Controller
                      name="password"
                      control={control}
                      render={({ field }) => (
                        <input
                          className={`form-control ${errors?.password ? "error-input" : ""}`}
                          type={eye ? "password" : "text"}
                          value={field.value || ""}
                          onChange={field.onChange}
                          autoComplete="current-password"
                          placeholder="Password"
                          style={{
                            paddingLeft: "16px",
                            paddingRight: "48px",
                            height: "52px",
                            borderRadius: "4px",
                            border: errors?.password ? "1px solid #dc2626" : "1px solid #000000",
                            fontSize: "16px",
                            transition: "all 0.2s",
                            background: "#ffffff",
                            width: "100%",
                            color: "#000000"
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#D3001A";
                            e.target.style.background = "#ffffff";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = errors?.password ? "#dc2626" : "#000000";
                            e.target.style.background = "#ffffff";
                          }}
                        />
                      )}
                    />
                    <span
                      onClick={onEyeClick}
                      style={{
                        position: "absolute",
                        right: "16px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#D3001A",
                        cursor: "pointer",
                        fontSize: "14px",
                        transition: "color 0.2s",
                        padding: "4px",
                        zIndex: 2,
                        fontWeight: "600"
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.color = "#b91c1c"}
                      onMouseLeave={(e) => e.currentTarget.style.color = "#D3001A"}
                      className={`fa-solid ${eye ? "fa-eye-slash" : "fa-eye"}`}
                    />
                  </div>
                  {errors.password?.message && (
                    <span style={{ 
                      color: "#dc2626", 
                      fontSize: "12px",
                      marginTop: "4px",
                      display: "block"
                    }}>
                      {errors.password?.message}
                    </span>
                  )}
                  <div style={{ 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center",
                    marginTop: "8px"
                  }}>
                    <div></div>
                    <Link 
                      to="/forgot-password"
                      style={{ 
                        fontSize: "14px",
                        color: "#D3001A",
                        textDecoration: "none",
                        fontWeight: "600"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.textDecoration = "underline";
                        e.currentTarget.style.color = "#b91c1c";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.textDecoration = "none";
                        e.currentTarget.style.color = "#D3001A";
                      }}
                    >
                      Forgot password?
                    </Link>
                  </div>
                </div>

                {/* Submit Button */}
                <div style={{ marginTop: "32px" }}>
                  <Button 
                    loading={loading} 
                    disabled={loading} 
                    label={loading ? "Signing in..." : "Sign in"} 
                    type="submit" 
                    className="btn btn-primary w-100"
                    style={{
                      height: "52px",
                      borderRadius: "8px",
                      fontSize: "16px",
                      fontWeight: "600",
                      background: loading ? "#9ca3af" : "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      border: "none",
                      boxShadow: loading ? "none" : "0 2px 8px rgba(211, 0, 26, 0.2)",
                      transition: "all 0.3s",
                      width: "100%",
                      color: "#ffffff"
                    }}
                  />
                </div>
              </form>
            )}

            {/* Footer - Copyright */}
            {isMobile && (
              <div className="text-center" style={{ 
                marginTop: "auto",
                paddingTop: "40px",
                paddingBottom: "24px",
                flexShrink: 0
              }}>
                <p style={{ 
                  color: "#9ca3af",
                  fontSize: "11px",
                  margin: 0,
                  lineHeight: "1.4"
                }}>
                  © {new Date().getFullYear()} Nando's ESS. All rights reserved.
                </p>
              </div>
            )}
            {!isMobile && (
              <div className="text-center" style={{ 
                marginTop: "24px",
                flexShrink: 0
              }}>
                <p style={{ 
                  color: "#6b7280",
                  fontSize: "12px",
                  margin: 0
                }}>
                  © {new Date().getFullYear()} Nando's ESS. All rights reserved.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
